import { Component, Input } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';

@Component({
	selector: 'app-drivers-documents-list-filters',
	templateUrl: './drivers-documents-list-filters.component.html',
	styleUrls: ['./drivers-documents-list-filters.component.css'],
})
export class DriversDocumentsListFiltersComponent extends FiltersComponent {
	@Input() documentKinds: Array<any>;

	filters = {
		kind: [],
	};
}
